// extracted by mini-css-extract-plugin
export default {"value":"copy-field_value__gWDo6","value-text":"copy-field_value-text__ojZl8"};